import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { TableWrapper } from './TableWrapper';

const StyledSkeleton = styled(Skeleton)`
  height: ${({ theme }) => theme.spacing.utils.pxToRem(44)};
  min-width: ${({ theme }) => theme.spacing.values.double};
`;

export const AUDIENCE_COUNTS_SKELETON_DATA_TEST = 'audience-counts-table-skeleton';

export const AudienceCountsTableSkeleton = () => (
  <TableWrapper data-test={AUDIENCE_COUNTS_SKELETON_DATA_TEST}>
    <StyledSkeleton />
  </TableWrapper>
);
